import {
    spaceMicro,
    spaceMini,
    spaceRegular,
    spaceMedium,
    spaceLarge,
    fontMini,
    sizeNano,
    fullHeight,
    spaceHuge,
    sizeHuge,
    spaceSmall,
    radiusMedium,
} from '@ui/styles/spaces';
import {
    pureWhite,
    lightGreyColor,
    lightMarineColorShade,
} from '@ui/styles/colors';

const TOP_MARGIN = 154;
const TOP_MARGIN_SHRUNK = 100;
const VERTICAL_SHRINK_BP = 1000;
const VERTICAL_STEPPER_HORIZONTAL_BP = 900;

export const formComposerChipStyle = {
    backgroundColor : 'transparent',
    marginTop       : -28,
};

export const selectStyle = {
    marginTop    : 16,
    marginBottom : 8,
    width        : '100%',
};

export const confirmButtonStyle = {
    marginTop   : spaceMedium,
    marginLeft  : spaceMicro,
    marginRight : spaceMicro,
};

export const sliderLabelStyle = {
    display        : 'flex',
    justifyContent : 'flex-start',
    alignItems     : 'center',
};

export const sliderLabelWrapperStyle = {
    paddingLeft   : 40,
    paddingRight  : 40,
    paddingTop    : 10,
    paddingBottom : 10,
};

export const sliderTextLabelStyle = {
    minWidth: 100,
};

export const sliderChipLabelStyle = {
    margin     : 0,
    marginLeft : spaceMini,
    height     : sizeNano,
    color      : 'rgba(255, 255, 255, .75)',
};

export const chipsSelectWrapperStyle = {
    display        : 'flex',
    justifyContent : 'space-between',
    alignItems     : 'flex-start' as 'flex-start',
    flexWrap       : 'wrap' as 'wrap',
    paddingBottom  : spaceLarge,
};

export const linearProgressStyle = {
    position : 'fixed' as 'fixed',
    zIndex   : 3,
    width    : '100%',
    top      : 0,
    height   : 6,
};

export const topStepperWrapperStyle = {
    position  : 'fixed' as 'fixed',
    zIndex    : 3,
    width     : '100%',
    top       : 6,
    height    : 68,
    overflow  : 'hidden' as 'hidden',
    left      : '50%',
    transform : 'translate(-50%)',

    [`@media screen and (min-width: ${VERTICAL_STEPPER_HORIZONTAL_BP}px)`]: {
        display: 'none',
    },
};

export const sideStepperWrapperStyle = {
    display         : 'none',
    flexDirection   : 'column' as 'column',
    justifyContent  : 'flex-start' as 'flex-start',
    alignItems      : 'flex-start' as 'flex-start',
    height          : fullHeight,
    left            : 0,
    top             : 0,
    paddingRight    : spaceLarge,
    paddingLeft     : spaceHuge * 2,
    paddingTop      : TOP_MARGIN_SHRUNK,
    paddingBottom   : spaceHuge,
    width           : sizeHuge,
    boxSizing       : 'border-box' as 'border-box',
    backgroundColor : pureWhite,
    position        : 'fixed' as 'fixed',

    [`@media screen and (min-height: ${VERTICAL_SHRINK_BP}px)`]: {
        paddingTop: TOP_MARGIN,
    },

    [`@media screen and (min-width: ${VERTICAL_STEPPER_HORIZONTAL_BP}px)`]: {
        display: 'flex' as 'flex',
    },
};

export const sideStepperLogoStyle = {
    width          : 60,
    objectFit      : 'contain' as 'contain',
    objectPosition : 'left' as 'left',

    [`@media screen and (min-height: ${VERTICAL_SHRINK_BP}px)`]: {
        width: 90,
    },

};

export const sideStepperMiniLogoStyle = {
    width          : 35,
    objectFit      : 'contain' as 'contain',
    objectPosition : 'center' as 'center',

    [`@media screen and (min-height: ${VERTICAL_SHRINK_BP}px)`]: {
        width: 50,
    },

};

export const sideStepperCatchStyle = {
    marginBottom : 0,
    marginTop    : spaceLarge,

    [`@media screen and (min-height: ${VERTICAL_SHRINK_BP}px)`]: {
        marginTop    : spaceHuge,
        marginBottom : spaceRegular,
    },
};

export const sideStepperStyle = {
    paddingLeft : 0,
    flexGrow    : 1,
    flexShrink  : 0,

    '& .MuiStepConnector-lineVertical': {
        opacity   : 0,
        minHeight : spaceRegular,
    },

    '& .MuiStepConnector-vertical': {
        marginLeft: spaceSmall + 1,
    },

    '& .MuiStepIcon-root': {
        width  : spaceMedium,
        height : spaceMedium,
    },

    [`@media screen and (min-height: ${VERTICAL_SHRINK_BP}px)`]: {
        '& .MuiStepConnector-lineVertical': {
            minHeight: spaceMedium,
        },

        '& .MuiStepConnector-vertical': {
            marginLeft: spaceRegular,
        },

        '& .MuiStepIcon-root': {
            width  : spaceLarge,
            height : spaceLarge,
        },
    },
};

export const stepButtonStyle = {
    width      : '100%',
    flexBasis  : '100%',
    flexShrink : 0,
};

export const stepperStyle = {
    background     : lightGreyColor,
    width          : '100%',
    overflowX      : 'auto' as 'auto',
    overflowY      : 'hidden' as 'hidden',
    boxSizing      : 'border-box' as 'border-box',
    paddingTop     : spaceRegular,
    scrollBehavior : 'smooth' as 'smooth',
    height         : 200,
};

export const formFieldsWrapperStyle = {
    height          : fullHeight,
    maxHeight       : fullHeight,
    boxSizing       : 'border-box' as 'border-box',
    paddingBottom   : 42,
    overflowY       : 'scroll' as 'scroll',
    backgroundColor : lightGreyColor,
    scrollBehavior  : 'smooth' as 'smooth',
};

export const formFieldsScrollWrapperStyle = {
    minHeight      : '100%',
    display        : 'flex',
    flexDirection  : 'column' as 'column',
    justifyContent : 'flex-start',
    paddingTop     : TOP_MARGIN_SHRUNK,
    boxSizing      : 'border-box' as 'border-box',

    [`@media screen and (min-height: ${VERTICAL_SHRINK_BP}px)`]: {
        paddingTop: TOP_MARGIN,
    },

    [`@media screen and (min-width: ${VERTICAL_STEPPER_HORIZONTAL_BP}px)`]: {
        paddingLeft: sizeHuge,
    },

    [`@media screen and (min-width: ${VERTICAL_STEPPER_HORIZONTAL_BP + 100}px)`]: {
        paddingLeft: sizeHuge - 50,
    },

    [`@media screen and (min-width: ${VERTICAL_STEPPER_HORIZONTAL_BP + 200}px)`]: {
        paddingLeft: sizeHuge - 100,
    },

    [`@media screen and (min-width: ${VERTICAL_STEPPER_HORIZONTAL_BP + 300}px)`]: {
        paddingLeft: sizeHuge - 150,
    },

    [`@media screen and (min-width: ${VERTICAL_STEPPER_HORIZONTAL_BP + 400}px)`]: {
        paddingLeft: sizeHuge - 200,
    },

    [`@media screen and (min-width: ${VERTICAL_STEPPER_HORIZONTAL_BP + 500}px)`]: {
        paddingLeft: 0,
    },
};

export const uploadedImageStyle = {
    width          : '100%',
    height         : 200,
    objectFit      : 'cover' as 'cover',
    objectPosition : '50% 50%',
    borderRadius   : radiusMedium,
    overflow       : 'hidden' as 'hidden',
};

const buttonPrevNextStyle = {
    position        : 'absolute' as 'absolute',
    backgroundColor : lightGreyColor,
    color           : lightMarineColorShade,
    borderRadius    : 0,
    height          : '100%',
    boxSizing       : 'content-box' as 'content-box',
    padding         : 0,
    zIndex          : 8,
    transition      : 'color .5s ease',
};

export const buttonPrevNextDisabledStyle = {
    color: 'transparent',
};

export const buttonPrevStyle = {
    ...buttonPrevNextStyle,
    left: 0,
};

export const buttonNextStyle = {
    ...buttonPrevNextStyle,
    right: 0,
};

export const getSideStepperNoticeStyle = {
    marginTop : spaceRegular,
    textAlign : 'left' as 'left',
    color     : `${lightMarineColorShade} !important`,
    width     : '100%',
    display   : 'block' as 'block',
    fontSize  : fontMini,

    '& a, & a:visited': {
        color: 'inherit',
    },
};

export const sentenceWrapperStyle = {
    marginTop      : 10,
    marginBottom   : -20,
    display        : 'flex',
    flexShrink     : 1,
    justifyContent : 'center',
};

export const sentenceStyle = {
    backgroundColor : lightGreyColor,
    paddingTop      : 5,
    paddingBottom   : 5,
    paddingLeft     : 15,
    paddingRight    : 15,
    borderRadius    : 15,
};
